const JSZip = require("jszip");
const { saveAs } = require("file-saver");
const { toast } = require("react-toastify");
const { ToWords } = require("to-words");

const currencyData = [
  { label: "THB", value: "THB" },
  { label: "USD", value: "USD" },
  { label: "GBP", value: "GBP" },
  { label: "EUR", value: "EUR" },
  { label: "JPY", value: "JPY" },
  { label: "HKD", value: "HKD" },
  { label: "MYR", value: "MYR" },
  { label: "SGD", value: "SGD" },
  { label: "BND", value: "BND" },
  { label: "CNY", value: "CNY" },
  { label: "IDR", value: "IDR" },
  { label: "MMK", value: "MMK" },
  { label: "INR", value: "INR" },
  { label: "KRW", value: "KRW" },
  { label: "LAK", value: "LAK" },
  { label: "PHP", value: "PHP" },
  { label: "TWD", value: "TWD" },
  { label: "NZD", value: "NZD" },
  { label: "CHF", value: "CHF" },
  { label: "DKK", value: "DKK" },
  { label: "NOK", value: "NOK" },
  { label: "SEK", value: "SEK" },
  { label: "CAD", value: "CAD" },
  { label: "RUB", value: "RUB" },
  { label: "VND", value: "VND" },
  { label: "ZAR", value: "ZAR" },
  { label: "AED", value: "AED" },
  { label: "BHD", value: "BHD" },
  { label: "OMR", value: "OMR" },
  { label: "QAR", value: "QAR" },
  { label: "SAR", value: "SAR" },
];

const bankName = [
  {
    label: "BANGKOK BANK PUBLIC COMPANY LTD. (Thailand) -0020000",
    value: "BANGKOK BANK PUBLIC COMPANY LTD. (Thailand) -0020000",
  },
  {
    label: "KASIKORNBANK PUBLIC COMPANY LIMITED (Thailand) -0040000",
    value: "KASIKORNBANK PUBLIC COMPANY LIMITED (Thailand) -0040000",
  },
  {
    label: "THE ROYAL BANK OF SCOTLAND N.V. (United Kingdom) -0050001",
    value: "THE ROYAL BANK OF SCOTLAND N.V. (United Kingdom) -0050001",
  },
  {
    label: "KRUNG THAI BANK PUBLIC COMPANY LTD. (Thailand) -0060000",
    value: "KRUNG THAI BANK PUBLIC COMPANY LTD. (Thailand) -0060000",
  },
  {
    label:
      "JPMORGAN CHASE BANK, NATIONAL ASSOCIATION (United States of America) -0080001",
    value:
      "JPMORGAN CHASE BANK, NATIONAL ASSOCIATION (United States of America) -0080001",
  },
  {
    label: "TMBTHANACHART BANK PUBLIC COMPANY LIMITED (Thailand) -0110000",
    value: "TMBTHANACHART BANK PUBLIC COMPANY LIMITED (Thailand) -0110000",
  },
  {
    label: "SIAM COMMERCIAL BANK PUBLIC COMPANY LTD. (Thailand) -0140000",
    value: "SIAM COMMERCIAL BANK PUBLIC COMPANY LTD. (Thailand) -0140000",
  },
  {
    label: "CITIBANK, N.A. (United States of America) -0170001",
    value: "CITIBANK, N.A. (United States of America) -0170001",
  },
  {
    label: "SUMITOMO MITSUI BANKING CORPORATION (Japan) -0180001",
    value: "SUMITOMO MITSUI BANKING CORPORATION (Japan) -0180001",
  },
  {
    label:
      "STANDARD CHARTERED BANK (THAI) PUBLIC CO., LTD. (Thailand) -0200000",
    value:
      "STANDARD CHARTERED BANK (THAI) PUBLIC CO., LTD. (Thailand) -0200000",
  },
  {
    label: "CIMB BANKTHAI PUBLIC COMPANY LIMITED (Thailand) -0220000",
    value: "CIMB BANKTHAI PUBLIC COMPANY LIMITED (Thailand) -0220000",
  },
  {
    label: "UNITED OVERSEAS BANK (THAI) PUBLIC CO., LTD. (Thailand) -0240000",
    value: "UNITED OVERSEAS BANK (THAI) PUBLIC CO., LTD. (Thailand) -0240000",
  },
  {
    label: "BANK OF AYUDHAYA PUBLIC COMPANY LTD. (Thailand) -0250000",
    value: "BANK OF AYUDHAYA PUBLIC COMPANY LTD. (Thailand) -0250000",
  },
  {
    label:
      "MEGA INTERNATIONAL COMMERCIAL BANK PUBLIC COMPANY LIMITED (Taiwan) -0260001",
    value:
      "MEGA INTERNATIONAL COMMERCIAL BANK PUBLIC COMPANY LIMITED (Taiwan) -0260001",
  },
  {
    label:
      "BANK OF AMERICA NATIONAL ASSOCIATION (United States of America) -0270001",
    value:
      "BANK OF AMERICA NATIONAL ASSOCIATION (United States of America) -0270001",
  },
  {
    label: "GOVERNMENT SAVING BANK (Thailand) -030---",
    value: "GOVERNMENT SAVING BANK (Thailand) -030---",
  },
  {
    label:
      "THE HONGKONG AND SHANGHAI BANKING CORPORATION LIMITED (Hong Kong and Shanghai) -0310001",
    value:
      "THE HONGKONG AND SHANGHAI BANKING CORPORATION LIMITED (Hong Kong and Shanghai) -0310001",
  },
  {
    label: "DEUTSCHE BANK AG. (Germany) -0320001",
    value: "DEUTSCHE BANK AG. (Germany) -0320001",
  },
  {
    label: "GOVERNMENT HOUSING BANK (Thailand) -033---",
    value: "GOVERNMENT HOUSING BANK (Thailand) -033---",
  },
  {
    label:
      "BANK FOR AGRICULTURAL AND AGRICULTURAL CO-OPERATIVES (Thailand) -0340001",
    value:
      "BANK FOR AGRICULTURAL AND AGRICULTURAL CO-OPERATIVES (Thailand) -0340001",
  },
  {
    label: "MIZUHO BANK, LTD. BANGKOK BRANCH (Japan) -0390001",
    value: "MIZUHO BANK, LTD. BANGKOK BRANCH (Japan) -0390001",
  },
  {
    label: "BNP PARIBAS, BANGKOK BRANCH (France) -0450010",
    value: "BNP PARIBAS, BANGKOK BRANCH (France) -0450010",
  },
  {
    label: "BANK OF CHINA (THAI) PUBLIC COMPANY LIMITED (China) -052---",
    value: "BANK OF CHINA (THAI) PUBLIC COMPANY LIMITED (China) -052---",
  },
  {
    label: "ISLAMIC BANK OF THAILAND (Thailand) -0660001",
    value: "ISLAMIC BANK OF THAILAND (Thailand) -0660001",
  },
  {
    label: "TISCO BANK PUBLIC COMPANY LIMITED (Thailand) -067---",
    value: "TISCO BANK PUBLIC COMPANY LIMITED (Thailand) -067---",
  },
  {
    label: "KIATNAKIN BANK PUBLIC COMPANY LIMITED (Thailand) -069---",
    value: "KIATNAKIN BANK PUBLIC COMPANY LIMITED (Thailand) -069---",
  },
  {
    label: "INDUSTRIAL AND COMMERCIAL BANK OF CHINA (THAI) PCL (China) -070---",
    value: "INDUSTRIAL AND COMMERCIAL BANK OF CHINA (THAI) PCL (China) -070---",
  },
  {
    label:
      "THE THAI CREDIT RETAIL BANK PUBLIC COMPANY LIMITED (Thailand) -0710001",
    value:
      "THE THAI CREDIT RETAIL BANK PUBLIC COMPANY LIMITED (Thailand) -0710001",
  },
  {
    label: "LAND AND HOUSES BANK PUBLIC COMPANY LIMITED (Thailand) -0730001",
    value: "LAND AND HOUSES BANK PUBLIC COMPANY LIMITED (Thailand) -0730001",
  },
  {
    label:
      "ANZ BANK (THAI) PUBLIC CO. LTD. (Australia and New Zealand) -0790001",
    value:
      "ANZ BANK (THAI) PUBLIC CO. LTD. (Australia and New Zealand) -0790001",
  },
  {
    label: "SUMITOMO MITSUI TRUST BANK (TH) PCL (Japan) -0800001",
    value: "SUMITOMO MITSUI TRUST BANK (TH) PCL (Japan) -0800001",
  },
  {
    label: "OTHER, please specify. (OTH) – 999---",
    value: "OTHER, please specify. (OTH) – 999---",
  },
];

const transformVendorTableDataResponse = (vendorTableData) => {
  if (vendorTableData && vendorTableData.length > 0) {
    return vendorTableData.map((e, index) => {
      return {
        vendor_id: e.id,
        vendor_code: e?.vendor_code
          ? e?.vendor_code !== "null"
            ? e?.vendor_code
            : "---"
          : "---",
        type_of_business: e.type_of_business ? e.type_of_business : "---",
        company_name_eng: e.company_name_eng ? e.company_name_eng : "---",
        user_id: e.user_id,
        Date: e.created_at ? e.created_at.split("T")[0] : "---",
        assigner_id: e.assigner_id,
        vendor_status: e.vendor_status,
        registration_type: e.registration_type,
        is_delete: e.is_delete,
        status: e.status,
        updated_at: e.updated_at.split("T")[0],
        current_group_name: e?.current_group_name,
        current_stage_user_name: e?.current_stage_user_name,
        rejected_by_group_name: e?.rejected_by_group_name,
        rejection_description: e?.rejection_description,
        binding_category: e.binding_category,
        binding_category_specify: e.binding_category_specify,
        current_stage_user_id: e?.current_stage_user_id,
        keys_updated: e?.keys_updated,
        name: e?.currentStageUserData?.name || "---",
      };
    });
  } else {
    return [];
  }
};

const transformUserManagementTable = (userManagementTable) => {
  if (userManagementTable && userManagementTable.length > 0) {
    return userManagementTable.map((e, index) => {
      return {
        user_id: e.user_id,
        assigner_type: e.assigner_type,
        name: e.name,
        password: e.password,
        phone_number: e.phone_number,
        user_name: e.user_name,
        created_at: e.created_at.split("T")[0],
        updated_at: e.updated_at,
        email: e.email,
      };
    });
  } else {
    return [];
  }
};

const transformPressReleaseTable = (pressReleaseTable) => {
  if (pressReleaseTable && pressReleaseTable.length > 0) {
    return pressReleaseTable.map((e, index) => {
      return {
        id: e.id,
        Title: e.title,
        press_image: e.press_image,
        press_url: e.press_url,
        Description: e.description,
        Status: e.press_status,
        Date: DateGenerator(e.created_at),
      };
    });
  } else {
    return [];
  }
};

const transformPrReleaseTableDataResponse = (prReleaseTable) => {
  if (prReleaseTable && prReleaseTable.length > 0) {
    return prReleaseTable.map((e, index) => {
      return {
        PrCreatedId: e?.PrCreatedId,
        PR_ID: e?.PR_ID || "---",
        PR_Company: e?.PR_Company || "---",
        PR_Description: e?.PR_Description || "---",
        PR_Date: e?.PR_Date || "---",
        PR_QTY: e?.PR_QTY || "---",
        PR_Unit: e?.PR_Unit || "---",
        PR_Group: e?.PR_Group || "---",
        PR_Status: e?.PR_Status,
        PR_description_Long: e?.PR_description_Long || "",
        PR_description_Short: e?.PR_description_Short || "",
        Delete_Flag: e?.Delete_Flag,
        status: e?.status,
        createdAt: e?.createdAt,
        updatedAt: e?.updatedAt,
        PR_VMS_Status: e?.PR_VMS_Status || "",
      };
    });
  } else {
    return [];
  }
};

const transformSupplierManagementTableDataResponse = (
  supplierManagementTable
) => {
  if (supplierManagementTable && supplierManagementTable.length > 0) {
    return supplierManagementTable.map((e, index) => {
      return {
        PoPrDbId: e?.PoPrDbId,
        PrLongText: e?.PrLongText,
        PRUnitPrice: e?.PRUnitPrice,
        PrShortText: e?.PrShortText,
        PrQTY: e?.PrQTY,
        PrDeliveryDate: e?.PrDeliveryDate
          ? e.PrDeliveryDate.split("T")[0]
          : "---",
        VmsStatus: e?.VmsStatus,
        SelectedForEvaluation: e?.SelectedForEvaluation,
        poData: e?.poData,
      };
    });
  } else {
    return [];
  }
};

const transformEvaluationManagementTableDataResponse = (eavluationTable) => {
  if (eavluationTable && eavluationTable.length > 0) {
    return eavluationTable.map((e, index) => {
      return {
        evaluationId: e?.evaluationId,
        prSapData: e?.prSapData,
        poSapData: e?.poSapData,
        poNo: e?.poNo,
        vendorCode: e?.vendorCode,
        status: e?.status,
      };
    });
  } else {
    return [];
  }
};

const transformJobManagementTableDataResponse = (jobManagementTable) => {
  if (jobManagementTable && jobManagementTable.length > 0) {
    return jobManagementTable.map((e, index) => {
      return {
        PrCreatedId: e?.PrCreatedId,
        PR_ID: e?.PR_ID || "---",
        PR_Company: e?.PR_Company || "---",
        PR_Description: e?.PR_Description || "---",
        PR_Date: e?.PR_Date || "---",
        PR_QTY: e?.PR_QTY || "---",
        PR_Unit: e?.PR_Unit || "---",
        PR_Group: e?.PR_Group || "---",
        PR_Status: e?.PR_Status,
        Delete_Flag: e?.Delete_Flag,
        status: e?.status,
        createdAt: e.createdAt ? e.createdAt.split("T")[0] : "---",
        updatedAt: e?.updatedAt,
        PrTitle: e?.PrTitle || "---",
        DeliveryDate: e?.DeliveryDate ? e.DeliveryDate.split("T")[0] : "---",
        BuyerName: e?.BuyerName || "---",
        JobPrDetails: e?.JobPrDetails,
        BiddingDate: e?.BiddingDate ? e.BiddingDate.split("T")[0] : "---",
        JobId: e?.JobId,
        JobStatus: e?.JobStatus,
        QuotationCount: e?.QuotationCount,
        finalCallSend: e?.finalCallSend,
        finalCallReceived:e?.finalCallReceived,
      };
    });
  } else {
    return [];
  }
};

const transformQtTableDataResponse = (qtnTable) => {
  if (qtnTable && qtnTable.length > 0) {
    return qtnTable.map((e, index) => {
      return {
        status: e?.status,
        createdAt: e.createdAt ? e.createdAt.split("T")[0] : "---",
        updatedAt: e?.updatedAt,
        JobId: e?.JobId,
        QtAttachments: e?.QtAttachments,
        vendor: e?.vendor,
        JobQuotationId: e?.JobQuotationId,
        AttachmentCount: e?.AttachmentCount,
        Delete_Flag: e?.Delete_Flag,
        VendorId: e?.VendorId,
        QuotationStatus: e?.QuotationStatus,
        phoneNo: e?.phoneNo,
        submissionType: e?.submissionType,
      };
    });
  } else {
    return [];
  }
};

const transformPurchasingGroupTable = (purchasingGroupTable) => {
  if (purchasingGroupTable && purchasingGroupTable?.length > 0) {
    return purchasingGroupTable?.map((e, index) => {
      return {
        id: e?.purchasing_group_id,
        Purchasinggroup: e?.purchasinggroup_name,
        Meaning: e?.meaning,
        Category: e?.category,
        Status:
          e?.current_status == "review"
            ? "Waiting Release"
            : e?.current_status == "released"
            ? "Released"
            : e?.current_status,
        Date: e?.created_at.split("T")[0],
      };
    });
  } else {
    return [];
  }
};

function convertToQueryString(queryParams) {
  const queryString = Object.entries(queryParams)
    .filter(([_, value]) => value !== undefined && value !== null)
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  return `?${queryString}`;
}

function convertStringToArray(str) {
  if (str.length > 0) {
    if (str.includes(",")) {
      return str.split(",");
    } else {
      return [str];
    }
  }
}

const handleKeyDown = (event) => {
  if (event.key === "Enter") {
    event.preventDefault();
  }
};

function isValidUrl(url) {
  try {
    new URL(url);
    return true;
  } catch (error) {
    return false;
  }
}

const subCategoryOptions = [
  { label: "ELECTRICAL", value: "ELECTRICAL" },
  { label: "INSTRUMENT", value: "INSTRUMENT" },
  { label: "MECHANICAL", value: "MECHANICAL" },
  {
    label: "PIPING & FITTINGS",
    value: "PIPING & FITTINGS",
  },
  {
    label: "INSTRUMENT SERVICE",
    value: "INSTRUMENT SERVICE",
  },
  {
    label: "ELECTRICAL SERVICE",
    value: "ELECTRICAL SERVICE",
  },
  { label: "CIVIL", value: "CIVIL" },
  {
    label: "HEALTH-ENVI SERVICES",
    value: "HEALTH-ENVI SERVICES",
  },
  {
    label: "INSPECTION SERVICE",
    value: "INSPECTION SERVICE",
  },
  {
    label: "MECHANICAL SERVICE",
    value: "MECHANICAL SERVICE",
  },
  {
    label: "PIPING SERVICES",
    value: "PIPING SERVICES",
  },
  {
    label: "LAB&CHEMICAL GOODS",
    value: "LAB&CHEMICAL GOODS",
  },
  { label: "OFFICE GOODS", value: "OFFICE GOODS" },
  {
    label: "SAFETY&PROTECTION GOODS",
    value: "SAFETY&PROTECTION GOODS",
  },
  { label: "IT GOODS", value: "IT GOODS" },
  { label: "CHEMICALS", value: "CHEMICALS" },
  {
    label: "INDUSTRIAL GAS",
    value: "INDUSTRIAL GAS",
  },
  { label: "PACKAGING", value: "PACKAGING" },
  { label: "Other", value: "Other" },
];

const handleOnWheel = (event) => {
  event.currentTarget.blur();
};

const formatNumberWithCommas = (value) => {
  if (value === null || value === undefined || isNaN(value)) {
    return "";
  }

  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

const ppeOptions = [
  { label: "Safety shoes", value: "Safety shoes" },
  { label: "Safety helmet", value: "Safety helmet" },
  { label: "Safety Glassed/Goggle", value: "Safety Glassed/Goggle" },
  { label: "Chemical Gloves", value: "Chemical Gloves" },
  { label: "Long sleeves shirt", value: "Long sleeves shirt" },
  { label: "Half Mask & Respirator", value: "Half Mask & Respirator" },
  { label: "Other. please specify", value: "Other. please specify" },
];

const formatValue = (num, decimalPoint = 2) => {
  let numarr = num?.toFixed(decimalPoint)?.split(".") || [];
  const integerPart = numarr?.[0] || 0;
  const decimalPart = numarr?.[1] || 0;
  return (
    integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
    (decimalPart ? `.${decimalPart}` : "")
  );
};
const formatNumberWithCommasandDecimals = (value, decimalPoint = 2) => {
  if (typeof value === "number") {
    return formatValue(value, decimalPoint);
  } else if (typeof value === "string") {
    const parsedValue = parseFloat(value);
    if (!isNaN(parsedValue)) {
      return formatValue(parsedValue);
    }
  }
  return value;
};
function formatNumber(numberString) {
  const integerPart = parseInt(numberString, 10);
  return integerPart.toLocaleString();
}

const cleanObject = (obj) => {
  const cleanedObj = {};
  for (const [key, value] of Object.entries(obj)) {
    if (value !== null && value !== undefined && value !== "") {
      cleanedObj[key] = value;
    }
  }
  return cleanedObj;
};

//function to generate date in correct format
function DateGenerator(data) {
  if (!data) {
    return null;
  }
  const date = new Date(data);
  return date.toLocaleDateString("en-GB");
}

function formatDate(date) {
  if (!date) return null;
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

function formatInputDate(dateString) {
  if (!dateString) return "";
  const date = new Date(dateString);
  if (isNaN(date)) return "";
  return date.toISOString().split("T")[0];
}

//This function would compare the given date with current date
// Condition if target date is greater than current date then it would return true else return false
function compareTargetandCurrentDate(dateString) {
  if (typeof dateString !== "string") {
    return null;
  }
  const targetDate = new Date(dateString);
  if (isNaN(targetDate.getTime())) {
    return null;
  }
  const currentDate = new Date();
  currentDate.setUTCHours(0, 0, 0, 0);
  return targetDate >= currentDate;
}

//function for calculating penalty
function calculatePenalty(poAmount, grDate, deliveryDate) {
  if (!poAmount) {
    toast.error("Missing purchase order amount (poAmount)");
    return;
  }

  if (!grDate) {
    toast.error("Missing goods receipt date (grDate)");
    return;
  }

  if (!deliveryDate) {
    toast.error("Missing delivery date (deliveryDate)");
    return;
  }
  const grDateObj = new Date(grDate);
  const deliveryDateObj = new Date(deliveryDate);

  const diffInTime = grDateObj - deliveryDateObj;
  const diffInDays = diffInTime / (1000 * 60 * 60 * 24);
  const penalty = poAmount * 0.005 * diffInDays;

  return penalty;
}

function numberToWords(number) {
  const toWords = new ToWords({
    localeCode: "en-US",
    converterOptions: {
      currency: false,
      ignoreDecimal: false,
      ignoreZeroCurrency: false,
    },
  });
  const wordNum = toWords.convert(parseFloat(number || 0));
  return wordNum;
}

const formatStringForCSV = (inputString) => {
  let formattedString = inputString?.replace(/\\"/g, '"');
  formattedString = formattedString?.replace(/,/g, ";");
  return formattedString;
};

const getFileNameFromUrl = (url) => {
  try {
    // Handle data URLs separately
    if (url.startsWith("data:")) {
      const mimeType = url.substring(url.indexOf(":") + 1, url.indexOf(";"));
      const extension = mimeType.split("/")[1] || "txt";
      return `file_from_data_url.${extension}`;
    }
    const urlObject = new URL(url);
    const pathname = urlObject.pathname;
    const parts = pathname.split("/");
    const encodedFileName = parts[parts.length - 1] || "file";

    // *** FIX: Decode the URI component to handle spaces (%20), parentheses, etc. ***
    return decodeURIComponent(encodedFileName);
  } catch (error) {
    // Fallback for non-standard URLs
    const parts = url.split("/");
    const lastPart = parts[parts.length - 1] || "file";
    const encodedFileName = lastPart.split("?")[0]; // Remove query parameters
    return decodeURIComponent(encodedFileName);
  }
};

const downloadFilesInZip = async (attachments, zipFolderName) => {
  const zip = new JSZip();
  const allFiles = attachments;
  try {
    // 1. Create an array of promises to fetch each file's data (blob) and name.
    const filePromises = attachments.map((url) =>
      fetch(url)
        .then((response) => {
          if (!response.ok) {
            throw new Error(`Failed to fetch ${url}: ${response.statusText}`);
          }
          return response.blob();
        })
        .then((blob) => ({
          blob,
          name: getFileNameFromUrl(url), // Get the dynamic, decoded filename
        }))
    );

    // 2. Wait for all files to be fetched.
    const files = await Promise.all(filePromises);

    // 3. Add each file to the zip archive with its correct name.
    files.forEach((file) => {
      zip.file(file.name, file.blob);
    });

    // 4. Generate the zip file content.
    const zipContent = await zip.generateAsync({
      type: "blob",
      compression: "DEFLATE",
      compressionOptions: {
        level: 9,
      },
    });

    // 5. Trigger the download.
    saveAs(zipContent, `${zipFolderName}.zip`);
  } catch (error) {
    toast.error(error?.message || "Something went wrong!");
  }
};

const compareDates = (GRDate, PrDeliveryDate) => {
  const isValidDate = (date) => !isNaN(new Date(date).getTime());

  if (!isValidDate(GRDate) || !isValidDate(PrDeliveryDate)) {
    return 0;
  }
  const grDate = new Date(GRDate);
  const prDeliveryDate = new Date(PrDeliveryDate);
  if (prDeliveryDate > grDate) {
    return 1;
  } else {
    return 0;
  }
};
const calculateDaysBetweenDates = (date1, date2) => {
  const d1 = new Date(date1);
  const d2 = new Date(date2);
  const timeDifference = Math.abs(d2 - d1);
  const daysDifference = timeDifference / (1000 * 3600 * 24);
  return daysDifference;
};

const secretKey = "mysecretkey12345";

const decryptData = (encryptedData, key) => {
  try {
    const decodedData = decodeURIComponent(atob(encryptedData));
    let parsed = JSON.parse(decodedData);
    if (typeof parsed === "string") {
      parsed = JSON.parse(parsed);
    }
    return parsed;
  } catch (error) {
    return null;
  }
};

const transformCycleData = (data = []) => {
  if (data && data?.length > 0) {
    return data?.map((item) => {
      const startDate = new Date(item?.start_date);
      if (item?.end_date) {
        const endDate = new Date(item?.end_date);

        // Formatting the date as "DD-MM-YYYY"
        const formatDate = (date) =>
          `${date.getDate().toString().padStart(2, "0")}-${(date.getMonth() + 1)
            .toString()
            .padStart(2, "0")}-${date.getFullYear()}`;

        const dayDifference = Math.ceil(
          (endDate - startDate) / (1000 * 60 * 60 * 24)
        );

        return {
          id: item.id,
          cycle_id: item.cycle_id,
          edit: `${formatDate(startDate)} To ${formatDate(endDate)}`,
          total: `${dayDifference} Days`,
        };
      } else {
        const endDate = new Date();
        const formatDate = (date) =>
          `${date.getDate().toString().padStart(2, "0")}-${(date.getMonth() + 1)
            .toString()
            .padStart(2, "0")}-${date.getFullYear()}`;

        const dayDifference = Math.ceil(
          (endDate - startDate) / (1000 * 60 * 60 * 24)
        );

        return {
          id: item.id,
          cycle_id: item.cycle_id,
          edit: `${formatDate(startDate)} To In Progress`,
          total: `${dayDifference} Days`,
        };
      }
    });
  }
  return [];
};

const transformTimeStampData = (data) => {
  const MS_PER_DAY = 24 * 60 * 60 * 1000;

  const result = data;

  if (result?.length === 0) return result;

  // result[0].dayDifference = "0 Days";

  for (let i = 0; i < result?.length; i++) {
    if (i == result?.length - 1) {
      result[i].dayDifference = "0 Days";
    } else {
      const nextDate = new Date(result[i + 1]?.created_at);
      const currentDate = new Date(result[i].created_at);

      let diffDays = Math.abs(
        Math.floor((currentDate - nextDate) / MS_PER_DAY)
      );
      result[i].dayDifference = diffDays + " Days";
    }
  }

  return result;
};

const formatISODate = (isoString = "") => {
  // Create a new Date object from the ISO string
  const date = new Date(isoString);

  // Extract date parts using the UTC methods to keep it consistent with the "Z" (UTC) format
  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Months are 0-indexed
  const day = String(date.getUTCDate()).padStart(2, "0");
  const hours = String(date.getUTCHours()).padStart(2, "0");
  const minutes = String(date.getUTCMinutes()).padStart(2, "0");
  const seconds = String(date.getUTCSeconds()).padStart(2, "0");

  // Return the formatted string
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

const getFileNameFromURL = (url) => {
  // Decode any URL-encoded characters, then split by "/" and get the last element
  const decodedURL = decodeURIComponent(
    url || "https://vinythai-assets.s3.ap-southeast-1.amazonaws.com/"
  );
  const segments = decodedURL.split("/");
  return segments.pop();
};

const checkEmptyOrNullString = (value) => {
  if (value === null || value === undefined) return false;
  if (typeof value === "number") {
    return value > 0;
  }
  if (typeof value === "string") {
    const trimmed = value.trim();
    if (trimmed === "") return false;
    const parsedValue = parseFloat(trimmed);
    if (!isNaN(parsedValue)) {
      return parsedValue > 0;
    }
    return false;
  }
  return false;
};

 const formatODSText = (text) => {
  if (!text) return '';
  
  return text
    .replace(/&Gt;/g, '>')
    .replace(/&Lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&lt;/g, '<')
    .replace(/&amp;/g, '&')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&#92;/g, '\\');
};
module.exports = {
  getFileNameFromURL,
  formatISODate,
  transformTimeStampData,
  transformCycleData,
  secretKey,
  decryptData,
  cleanObject,
  formatNumberWithCommasandDecimals,
  convertToQueryString,
  handleKeyDown,
  currencyData,
  bankName,
  transformVendorTableDataResponse,
  convertStringToArray,
  transformUserManagementTable,
  transformPressReleaseTable,
  isValidUrl,
  handleOnWheel,
  subCategoryOptions,
  formatNumberWithCommas,
  ppeOptions,
  transformPurchasingGroupTable,
  transformPrReleaseTableDataResponse,
  transformJobManagementTableDataResponse,
  transformQtTableDataResponse,
  transformSupplierManagementTableDataResponse,
  transformEvaluationManagementTableDataResponse,
  DateGenerator,
  formatDate,
  formatInputDate,
  compareTargetandCurrentDate,
  calculatePenalty,
  numberToWords,
  formatNumber,
  downloadFilesInZip,
  formatStringForCSV,
  compareDates,
  calculateDaysBetweenDates,
  checkEmptyOrNullString,
  formatODSText,
};